export default "__VITE_ASSET__CEYsrloF__"